import { useTranslation } from 'react-i18next';
import { MdOutlineLocationOn } from "react-icons/md";
import { FaLinkedinIn, FaTwitter, FaInstagram } from "react-icons/fa";

import styles from './index.module.scss';

export default function Footer({ handleOpenModal }) {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.row}>
          <div className={styles.footerInfo}>
            <h1>{t('where_are_we')}</h1>
            <div>
              <h2><MdOutlineLocationOn />{t('location_brazil')}</h2>
              <h2><MdOutlineLocationOn />{t('location_India')}</h2>
            </div>
          </div>

          <div className={styles.stripe}></div>

          <div className={styles.nav}>
            <h2>{t('all_rights_reserved')}</h2>

            <nav>
              <ul>
                <li><a target="_blank" href="https://www.datamar.com.br">www.datamar.com.br</a></li>
                <li><a target="_blank" href="https://www.datamarnews.com">datamarnews.com</a></li>
                <li><button onClick={handleOpenModal}>{t('terms_and_conditions')}</button></li>
              </ul>

              <ul>
                <li><a target="_blank" href="https://br.linkedin.com/company/datamar-trade-intelligence/"><FaLinkedinIn /></a></li>
                <li><a target="_blank" href="https://twitter.com/datamar"><FaTwitter /></a></li>
                <li><a target="_blank" href="https://www.instagram.com/datamar_sp/"><FaInstagram /></a></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  )
}